import styled from 'styled-components';

export const Wrapper = styled.div`
  position: fixed;
  border-radius: 2rem;
  right: 1rem;
  bottom: 1rem;
  z-index: 1000;
  padding: 2rem;
  box-shadow: ${({ theme }) => theme.boxShadow.black};
  background: ${({ theme }) => theme.colors.functional.white};
  color: #ccc;
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.functional.darkestGray};
  a,
  button {
    margin-bottom: 0.5rem;
    display: block;
    text-decoration: underline;
    font-weight: bold;
    &:hover {
      color: ${({ theme }) => theme.colors.functional.black};
    }
  }
  p {
    margin: 1rem 0 0.5rem;
    &:first-child {
      margin-top: 0;
    }
  }
`;
